export default {
    parseCategories(state) {
        if (state.categories) {
            state.prettyCategories = [];
            state.categories.forEach(cat => {
                state.prettyCategories.push(cat.Name);
            });
        } else
            state.prettyCategories = [];
    }

}